{
  "sitemap": {
    "sitemap": "Plan du site",
    "title": {
      "create": "Créer un plan du site",
      "edit": "Modifier le plan du site"
    },
    "name": "Nom",
    "key": "Code clé (3 lettres)",
    "colour_of_label": "Couleur de l'étiquette",
    "versions": "Versions",
    "there_are_no_versions": "Il n'existe aucune version sur ce plan du site",
    "add_version": "Ajouter une version",
    "map_order": "Ordre des cartes"
  },
  "sitemapVersion": {
    "sitemapVersion": "Version du plan du site",
    "title": {
      "create": "Création d'une version du plan du site",
      "edit": "Modifier la version d'un plan de site"
    },
    "version": "Version",
    "name": "Nom",
    "level_abbreviation": "Abréviation du niveau (3 caractères maximum)",
    "level_index": "Indice",
    "tiles": "Carreaux",
    "upload_tiles": "Télécharger des vignettes",
    "remove_tiles": "Supprimer les carreaux",
    "style": "Style",
    "upload_style": "Style de téléchargement",
    "remove_style": "Supprimer le style",
    "levels": "Niveaux",
    "there_are_no_levels": "Il n'y a aucun niveau dans cette version",
    "add_level": "Ajouter un niveau",
    "uploading_tiles": "Téléchargement de {{ level }}",
    "retry": "Réessayez",
    "enter_level_name": "Entrez le nom du niveau",
    "level_index_must_be_unique": "L'indice de niveau doit être unique",
    "Pending": "En attente",
    "Active": "Actif",
    "Deleted": "Supprimé",
    "Uploading": "Téléchargement",
    "Extracting": "Extraction",
    "Reviewing": "Révision",
    "Tiling": "Carrelage",
    "Failed": "Échoué",
    "deleteVersionWarning": "Un plan du site doit avoir au moins une version. Veuillez créer une nouvelle version avant de la supprimer"
  },
  "sitemapVersionLevel": {
    "sitemapVersionLevel": "Niveau de version du plan de site",
    "level": "Niveau"
  },
  "levelsReassignmentDialog": {
    "title": "Réaffectation de niveau",
    "paragraph1": "Vous êtes sur le point de supprimer certains niveaux, mais certains objets cartographiques peuvent exister sur ces niveaux.",
    "paragraph2": "Vers quels niveaux aimerais-tu les déplacer ?"
  },
  "cad": {
    "cadFile": "fichier CAD",
    "remove": "Fichier DWG",
    "upload": "Télécharger le fichier DWG",
    "coordinateSystem": "Système de coordonnées",
    "preset": {
      "title": "Configuration prédéfinie",
      "placeholder": "Choisissez parmi les niveaux de version de plan de site existants"
    }
  },
  "sitemap_default": {
    "floor": "Rez-de-chaussée"
  }
}